<template>
  <el-dialog
    title="选择专属导购"
    :visible.sync="visible"
    width="900px"
    top="8vh"
    append-to-body
    custom-class="exclusive-guide-dialog"
    :close-on-click-modal="!saving"
    :close-on-press-escape="!saving"
    :show-close="!saving"
  >
    <div class="guide-section-title">当前专属导购</div>
    <div class="guide-current">{{ currentName }}</div>
    <div class="guide-section-title">可选导购</div>
    <div v-loading="loading" class="guide-list">
      <div v-if="error" class="guide-empty">
        加载失败，<el-button type="text" @click="loadList">点击重试</el-button>
      </div>
      <div v-else-if="!loading && !list.length" class="guide-empty">暂无专属导购</div>
      <el-radio-group v-else v-model="selectedId" :disabled="loading || saving" class="guide-grid">
        <el-radio v-for="item in list" :key="item.id" :label="String(item.id)" :title="item.name" border>{{ item.name }}</el-radio>
      </el-radio-group>
    </div>
    <div slot="footer" class="guide-footer">
      <el-button :loading="saving" :disabled="loading || error || !selectedId || !list.length" @click="confirm">
        确认切换
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSgStaffList, updateSgStaff } from '@/api/userApi';
import ls from '@/utils/localStorage';

export default {
  props: { user: { type: Object, default: () => ({}) } },
  data() {
    return { visible: false, loading: false, saving: false, error: false, list: [], selectedId: '' };
  },
  computed: {
    currentName() {
      if (this.user.sgStaffId == null || this.user.sgStaffId === '') return '无';
      const current = this.list.find((item) => String(item.id) === String(this.user.sgStaffId));
      return (current && current.name) || '无';
    },
  },
  watch: {
    'user.systemSource': {
      immediate: true,
      handler(value) {
        if (value === 'Y') this.loadList();
      },
    },
    currentName: {
      immediate: true,
      handler(name) {
        this.$emit('name-change', name);
      },
    },
  },
  methods: {
    open() {
      this.selectedId = this.user.sgStaffId == null ? '' : String(this.user.sgStaffId);
      this.visible = true;
      this.loadList();
    },
    async loadList() {
      if (this.loading) return;
      this.loading = true;
      this.error = false;
      this.list = [];
      try {
        const res = await getSgStaffList();
        if (!res || !Array.isArray(res.data)) throw new Error('Invalid guide list');
        this.list = res.data.filter((item) => item.sgStaffId != null && item.sgStaffId !== '').map((item) => ({ id: item.sgStaffId, name: item.name }));
      } catch (error) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    async confirm() {
      if (this.saving || this.loading || this.error) return;
      const selected = this.list.find((item) => String(item.id) === this.selectedId);
      if (!selected) return;
      if (String(this.user.sgStaffId) === String(selected.id)) {
        this.visible = false;
        return;
      }
      if (this.user.id == null || !this.user.username) {
        this.$message.error('用户信息不完整，请重新登录后重试');
        return;
      }
      this.saving = true;
      try {
        const res = await updateSgStaff({ userId: this.user.id, name: this.user.username, sgStaffId: selected.id });
        if (!res || (res.code != null && Number(res.code) !== 0)) throw new Error('Update failed');
        const info = this.$store.state.user.userInfo || {};
        const userInfo = { ...info, sgStaffId: selected.id, sgStaffName: selected.name };
        this.$store.commit('SET_USER_INFO', userInfo);
        ls.set('userInfo', userInfo);
        this.visible = false;
        this.$message.success({ message: `已切换专属导购为 ${selected.name}`, duration: 1000 });
      } catch (error) {
        this.$message.error('切换失败，请重试');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.guide-section-title {
  display: table;
  padding: 8px 14px;
  margin-bottom: 18px;
  border-radius: 4px;
  color: #d74e10;
  background: #fcf3e7;
}
.guide-current {
  width: 280px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  margin-bottom: 20px;
  border: 1px solid #f0dfd3;
  border-radius: 6px;
  background: #fffaf6;
  overflow-wrap: anywhere;
}
.guide-list {
  min-height: 120px;
  max-height: min(320px, 40vh);
  overflow-x: hidden;
  overflow-y: auto;
}
.guide-grid {
  display: grid;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  padding: 4px 2px;
}
.guide-grid .el-radio.is-bordered {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  margin: 0 !important;
  padding: 0 14px;
  border-radius: 6px;
  transition: border-color 0.2s, background-color 0.2s;
}
.guide-grid .el-radio.is-bordered:hover {
  border-color: #ec9368;
  background: #fffaf6;
}
.guide-grid .el-radio.is-bordered.is-checked {
  border-color: #ec9368;
  background: #fff4ec;
}
.guide-grid /deep/ .el-radio__input {
  flex-shrink: 0;
}
.guide-grid /deep/ .el-radio__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.guide-empty {
  padding: 32px 0;
  text-align: center;
  color: #999;
}
.guide-footer {
  text-align: center;
  padding: 8px 0;
}
.guide-footer .el-button {
  width: 220px;
  background: #d74e10;
  border-color: #d74e10;
  color: #fff;
  border-radius: 6px;
}
.guide-footer .el-button.is-disabled {
  background: #edb398;
  border-color: #edb398;
}
</style>

<style>
.exclusive-guide-dialog {
  max-width: calc(100vw - 40px);
  border-radius: 10px;
  overflow: hidden;
}
.exclusive-guide-dialog .el-dialog__header {
  padding: 22px 28px 18px;
  border-bottom: 1px solid #f0f0f0;
}
.exclusive-guide-dialog .el-dialog__title {
  font-weight: 600;
}
.exclusive-guide-dialog .el-dialog__body {
  padding: 24px 28px 12px;
}
.exclusive-guide-dialog .el-dialog__footer {
  padding: 16px 28px 20px;
}
@media (max-width: 640px) {
  .exclusive-guide-dialog .guide-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
